export const CREATE_POST="CREATE_POST";
export const POST_DETAILS="POST_DETAILS";
export const POST_DATA="POST_DATA";
export const REMOVE_POST_DATA="REMOVE_POST_DATA";


